import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Component({
  selector: 'common-ui-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {

  @Input()
  public message: string;

  @Input()
  public type: 'danger' | 'info' | 'eric-error' | 'warning';

  @Output() selected: EventEmitter<string> = new EventEmitter<string>();

  @HostListener('click') onClick(): void {
    this.selected.emit(this.message);
  }
}
